(function ($) {
// плавная прокрутка
//     $(function () {
//         $('.smooth-scroll').click(function () {
//             if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
//                 var target = $(this.hash);
//                 target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
//                 if (target.length) {
//                     $('html, body').animate({
//                         scrollTop: target.offset().top
//                     }, 1000);
//                     return false;
//                 }
//             }
//         });
//     });

// основные функции посадки
    $(document).ready(function () {
        // проверяем div - чтобы код не выполнялся на других страницах
        if ( $('div').is('#main-summer-landing') || $('div').is('#main-landing') ) {
            /**
             * Игорь просил написать этот комент:
             * "это грязный хак, но и так сойдет" (c)
             */
            if ($('div').is('.split-courses')) {
                var scope = angular.element(document.getElementsByClassName("common-form")).scope();
                var regionElem = $('form.common-form select[data-ng-model="fields.region"]');
                var courseElem = $('form.common-form select[data-ng-model="fields.course"]');
            } else {
                var scope = angular.element(document.getElementsByClassName("small-order-form")).scope();
                var regionElem = $('form.small-order-form select.select-region');
                var courseElem = $('form.small-order-form select.select-course');
            }


            function updateRegion (region) {

                if  ($('div').is('.partners-cpa-landing')) {
                    // nothing
                } else {
                    scope.fields.region = region;
                    scope.$apply();
                    regionElem.find('option[value="' + scope.fields.region + '"]').prop('selected', true).trigger('change');
                }
            }

            // проверяем куку с регионом
            if (App.cookie.get('region')) {

                $('#selectedRegion').find('strong').text(App.cookie.get('region')).css('text-decoration', 'underline');

                updateRegion(App.cookie.get('region'));

            } else {

                // пробуем запросить регион у яндекса
                window.onload = function () {
                    if (ymaps.geolocation.country === 'Россия') {

                        //console.log(ymaps.geolocation.region);

                        $('#selectedRegion').find('strong').text(ymaps.geolocation.region).css('text-decoration', 'underline');

                        App.cookie.set('region', ymaps.geolocation.region);

                        updateRegion(App.cookie.get('region'));

                        $('#selectedRegion').popover({html: true, content: "<center>Ваш регион:<br><b>" + ymaps.geolocation.region + "</b>?<br><br><b id='yes'><u>Да</u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span id='no'>Нет</span><br><center>", placement: "bottom"});
                        $('#selectedRegion').popover('show');

                    } else {
                        $('#selectedRegion').popover({html: true, content: "<br><center id='yes'><b>Выберите регион<br></b><br><center>", placement: "bottom"});

                        $('#selectedRegion').popover('show');
                    }
                }

            }

            // клики по поповеру с регионом
            // дестроим при клике на ДА (регион итак записался в куку)
            $(document).on('click', '#yes', function (e) {
                e.preventDefault();

                $('#selectedRegion').popover('destroy');

            });

            // при клике нет, открываем модальку
            $(document).on('click', '#no', function (e) {
                e.preventDefault();

                $('#regionSelect').modal('show');
            });

            // подстановка региона в форму
            $(document).on('click', '#main-summer-landing #regionSelect li', function (e) {

                var selectedRegionShow = $('#selectedRegion');
                var selectedR = $.trim($(this).text());

                //console.log( selectedR );

                $('#regionSelect').modal('hide');

                App.cookie.set('region', selectedR);
                selectedRegionShow.find('strong').text(selectedR).css('text-decoration', 'underline');

                updateRegion(selectedR);

                return true;
            });

            // авто-переключение табов
            if ( $('#courses').length ) {
                var tabChange = function () {
                    var tabs = $('.courses-tabs > li');
                    var active = tabs.filter('.active');
                    var next = active.next('li').length ? active.next('li').find('a') : tabs.filter(':first-child').find('a');
                    // Use the Bootsrap tab show method
                    next.tab('show');
                };
                    // Tab Cycle function
                var tabCycle = setInterval(tabChange, 7000);

                    // Tab click event handler
                $('.courses-tabs a, .course-click').on('click', function (e) {
                    e.preventDefault();
                    // Stop the cycle
                    clearInterval(tabCycle);
                    // Show the clicked tabs associated tab-pane
                    $(this).tab('show');
                    // Start the cycle again in a predefined amount of time
                    setTimeout(function () {
                        //tabCycle = setInterval(tabChange, 5000);
                    }, 15000);
                });
            }


            // убираем фейк курсор
            $(document).on('click, focus', '#main-summer-landing input[name="name"]', function (e) {
                $('.fake-cursor').hide();
            });


            // ставим в форму курс по клику
            $(document).on('click', '.course-click', function (e) {
                e.preventDefault();

                var courseId = $(this).data('course-id');
                var target = ( $('div').is('.split-courses') ? $('.common-form') : $('.small-order-form') );

                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);

                //  обновление блока с заявкой

                scope.fields.course = courseId;
                scope.$apply();
                courseElem.find('option[value=' + courseId + ']').prop('selected', true).trigger('change');

                return true;
            });

        }
    });


})(jQuery);



